<ng-container *transloco="let t" class="container">
  <app-admin-modal-layout
          [title]="title ?? ''"
          (onSave)="onSave()"
          [saveDisabled]="disabled"
          (onClose)="onDismissClick()"
  >
    <div class="d-flex flex-column align-items-center">
      <div class="py-4 w-100">
        <app-search-rounded
                [name]="filteredInput"
                [placeholder]="t('explore.search')"
                (searchEmitter)="handleSearchInput($event)"
        ></app-search-rounded>
      </div>

      @if (filteredItems && filteredItems.length > 0 && !allHidden) {
      <div class="ps-4 w-100">
        <div class="d-flex w-100 fw-bold list-title-underline">
      {{ tableColumnName ? t(tableColumnName) : "" }}
      </div>

      @for (item of filteredItems; track item; let idx = $index) {
      @if (item.visible) {
      <ng-container>
        <div class="d-flex w-100">
          <div class="flex-grow-1 item-underline d-flex align-items-center">
          {{ item.name }}
            @if (item.description) {
            <span class="ps-3 fw-300 fst-italic">
               -
            </span>
            <span class="ps-3 fw-300 fst-italic">
               {{item.description}}
            </span>
          }
      @if (item.tooltipMessage) {
      <div class="ms-2 fs-14" style="color: var(--badge-orange-color);">
        <i
                class="bi bi-info-circle"
                [ngbTooltip]="t(item.tooltipMessage)"
                placement="top"
        ></i>
      </div>
      }
      </div>

      <div class="item-underline">
        <input
          class="form-check-input"
          type="checkbox"
          [disabled]="filteredItems[idx].disabled"
          [(ngModel)]="filteredItems[idx].selected"
          (change)="onItemChange(item)"
        >
      </div>
    </div>

    @if (item.subItems && item.subItems.length > 0) {
      <ng-container>
        @for (subItem of item.subItems; track subItem; let jdx = $index) {
        @if (subItem.visible) {
        <div class="d-flex w-100">
          <div class="flex-grow-1 item-underline ps-4">
            {{ subItem.name }}
          </div>
          <div>
            @if (subItemCheckboxEnabled) {
            <div class="item-underline">
              <input
                class="form-check-input"
                type="checkbox"
                [disabled]="filteredItems![idx].subItems![jdx].disabled"
                [(ngModel)]="filteredItems![idx].subItems![jdx].selected"
                (change)="onSubItemChange(item)"
              >
            </div>
            }
          </div>
        </div>
        }
        }
      </ng-container>
      }
      </ng-container>
      }
      }
      </div>
      } @else {
      <div class="px-3 px-lg-4 pt-4 pb-3">
        <app-empty-state [addPaddingBottom]="false" />
      </div>
      }
    </div>
  </app-admin-modal-layout>
</ng-container>
